export const SAVE_CHANGES = "SAVE_CHANGES";
export const DELETE_PERSON = "DELETE_PERSON";
export const ADD_PERSON = "ADD_PERSON";
export const CHANGE_DEFAULT_PERSON = "CHANGE_DEFAULT_PERSON";
export const SET_INIT_PERSONS = "SET_INIT_PERSONS";


// WEBPACK FOOTER //
// ./src/_app/clients/constants/clients-constants.js